<template>
    <div>
        <div style="display:flex;align-items:center;">
            <div>
                <div class="value-wrapper">
                    <div class="value-line">
                        <div class="left">
                            Budgetteret
                        </div>
                        <div class="right">
                            {{ totals[0] | currency }}
                        </div>
                    </div>
                    <div class="value-line">
                        <div class="left">
                            Realiseret
                        </div>
                        <div class="right">
                            {{ totals[1] | currency }}
                        </div>
                    </div>
                    <div class="value-line">
                        <div class="left">
                            Difference
                        </div>
                        <div class="right" :class="{'good': totals[2] > 0, 'bad': totals[2] < 0}">
                            <span v-if="totals[2] > 0">+</span>{{ totals[2] | currency }}
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding-left:32px;padding-bottom:16px;">
                Fordeling:&nbsp;&nbsp;
                <div class="employee-switcher">
                    <div class="employee-switcher-option" @click="divisionOption = 1" :class="{'selected': divisionOption === 1}">
                        Budgetlinjer
                    </div>
                    <div class="employee-switcher-option" @click="divisionOption = 2" :class="{'selected': divisionOption === 2}">
                        Opgavetyper
                    </div>
                </div>
            </div>
        </div>

        <minuba-budget-report-linetypes :rows="lineTypes" :loading="loading" v-show="divisionOption === 1"></minuba-budget-report-linetypes>

        <minuba-budget-report-projecttypes :rows="projectTypes" :loading="loading" v-show="divisionOption === 2"></minuba-budget-report-projecttypes>
    </div>
</template>

<script>
import * as minubaBudgetService from '@/services/minubaBudgetService'

export default {
    data () {
        return {
            divisionOption: 1,
            loading: true,
            lineTypes: [],
            projectTypes: []
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            // this.$emit('finishedLoading', null)
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            minubaBudgetService.report(params, (response) => {
                this.lineTypes = response.data.line_types
                this.projectTypes = response.data.project_types
                // this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        },
        totals () {
            if (this.lineTypes.length) {
                let proposal = 0
                let expended = 0
                this.lineTypes.forEach((row) => {
                    proposal += row.proposal_cost
                    expended += row.expended_cost
                })
                let difference = proposal - expended
                return [
                    proposal,
                    expended,
                    difference
                ]
            }
            return [null, null, null]
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    },
    components: {
        'minuba-budget-report-linetypes': require('./minubaBudgetLineTypes.vue'),
        'minuba-budget-report-projecttypes': require('./minubaBudgetProjectTypes.vue')
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .good, .bad {
        font-weight: 700;
    }

    .good {
        color: $color--good;
    }

    .bad {
        color: $color--bad;
    }

</style>



// WEBPACK FOOTER //
// minubaBudgetReport.vue?b6d4fd90